/* eslint arrow-body-style: */
import {
	getAllCategories as apiGetAllCategories,
	getTopCategories as apiGetTopCategories,
} from 'api/Categories';
import { isCancel, mustRefetch } from 'api/Helpers';
import KioskLog from 'models/KioskLog';
import {
	IS_FETCHING,
	FETCH_ERROR,
	LAST_FETCH_TIME,
	RECEIVE_TOP_CATEGORIES,
	RECEIVE_ALL_CATEGORIES,
	RECEIVE_TOP_FEATURED_IMAGES,
} from './constants';

const updateFetchStatus = isFetching => ({
	type: IS_FETCHING,
	isFetching,
});

const updateFetchError = fetchError => ({
	type: FETCH_ERROR,
	fetchError,
});

const receiveTopCategories = categories => ({
	type: RECEIVE_TOP_CATEGORIES,
	categories,
});

const receiveAllCategories = categories => ({
	type: RECEIVE_ALL_CATEGORIES,
	categories,
});

const receiveTopFeaturedImages = topFeaturedImages => ({
	type: RECEIVE_TOP_FEATURED_IMAGES,
	topFeaturedImages,
});

const updateLastFetchTime = () => ({
	type: LAST_FETCH_TIME,
	lastFetchTime: Date.now(),
});

// Thunks

/**
 * Get a master list of all available categories.
 * The will not refetch if we have the data in the store.
 * @param {axios cancel token} cancelToken
 * Throws an error if the response status is not in the 2xx or 3xx family
 */
const getAllCategories = cancelToken => {
	return (dispatch, getState) => {
		// This data does not need to be refetched if we already have it in our store.
		const { categories } = getState();
		if (categories.get('allCategories').size !== 0) {
			return false;
		}

		dispatch(updateFetchStatus(true));

		return apiGetAllCategories(cancelToken)
			.then(response => {
				dispatch(updateFetchStatus(false));
				dispatch(receiveAllCategories(response.data.results.categories));
			})
			.catch(error => {
				dispatch(updateFetchStatus(false));
				if (isCancel(error)) {
					// Request was canceled.
					return;
				}

				dispatch(updateFetchError(error));
			});
	};
};

/**
 * Get a list of all top level categories.
 * The will not refetch if the cache has not been invalidated.
 * @param {axios cancel token} cancelToken
 * Throws an error if the response status is not in the 2xx or 3xx family
 */
const getTopCategories = cancelToken => {
	return (dispatch, getState) => {
		const { categories } = getState();
		const lastFetchTime = categories.get('lastFetchTime');
		if (!mustRefetch(lastFetchTime)) {
			return false;
		}

		dispatch(updateFetchStatus(true));

		return apiGetTopCategories(cancelToken)
			.then(response => {
				dispatch(updateFetchStatus(false));
				dispatch(receiveTopCategories(response.data.results.subCategories));
				dispatch(receiveTopFeaturedImages(response.data.results.topFeaturedImages));
				dispatch(updateLastFetchTime());
			})
			.catch(error => {
				dispatch(updateFetchStatus(false));
				if (isCancel(error)) {
					// Request was canceled.
					return;
				}
				const log = new KioskLog(error, 'Error file location: redux/domain/Categories/actions');
				log.postMessage();
				// note: if we throw here nothing will catch this.
				dispatch(updateFetchError(error));
			});
	};
};

export {
	getAllCategories,
	getTopCategories,
	receiveAllCategories,
	receiveTopCategories,
	receiveTopFeaturedImages,
	updateFetchError,
	updateLastFetchTime,
	updateFetchStatus,
};
